export const STATUS_LIST = [
  'ALL',
  'RUNNING',
  'CREATING',
  'DELETING',
  'DELETED',
  'STOPPED',
  'UPGRADING',
  'DELETION_FAILED',
].map((status) => ({ id: status, name: status }));

export const DB_SERVER_TYPE = {
  AUXILIARY: 'DBSERVER_AUXILIARY',
} as const;
